import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './app';
// Este import é crucial: ele aponta para o arquivo que gerencia o ciclo de vida do SW
import * as serviceWorker from './serviceWorker';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Global.css';
import './styles/bootstrap-screens.css';

const isResizeObserverError = (message) =>
  typeof message === 'string'
  && (message.includes('ResizeObserver loop completed')
    || message.includes('ResizeObserver loop limit exceeded'));

window.addEventListener(
  'error',
  (e) => {
    if (isResizeObserverError(e.message) || isResizeObserverError(e.error?.message)) {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  },
  true,
);

window.addEventListener('unhandledrejection', (e) => {
  if (isResizeObserverError(e.reason?.message)) {
    e.preventDefault();
  }
});

if (process.env.NODE_ENV === 'development') {
  const origConsoleError = window.console.error;
  window.console.error = (...args) => {
    if (args.some((a) => typeof a === 'string' && a.includes('ResizeObserver'))) {
      return;
    }
    origConsoleError(...args);
  };
}

const container = document.getElementById('root');
const root = createRoot(container);

root.render(<App />);

serviceWorker.register({
  onUpdate: (registration) => {
    if (registration.waiting) {
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
      registration.waiting.addEventListener('statechange', (e) => {
        if (e.target.state === 'activated') {
          window.location.reload();
        }
      });
    }
  },
});